// ── AI 화면 공용 색상 팔레트 (PlanNEL 기준 — plannel_ai_scenario_planning.html) ──
// AiScenarioPlanning.js 에서 추출 — ScenarioManage 등 별도 화면 파일과 공유(단방향 import).
export const C = {
  acc:    "#185FA5", accL:  "#E6F1FB", accM:  "#378ADD", accS:  "#B5D4F4", accT:  "#0C447C",
  g1:     "#1D9E75", g1l:   "#E1F5EE", g1t:   "#085041", g1s:   "#5DCAA5",
  g2:     "#BA7517", g2l:   "#FAEEDA", g2t:   "#633806", g2s:   "#EF9F27",
  g3:     "#E24B4A", g3l:   "#FCEBEB", g3t:   "#791F1F", g3s:   "#FCA5A5",
  bg:     "#F8F9FB", bg2:   "#FFFFFF", bg3:   "#F1F4F8",
  text1:  "#111827", text2: "#4B5563", text3: "#9CA3AF",
  border: "#E5E7EB",
};

// ── 모듈별 색 토큰 (시나리오 관리 화면) ─────────────────────────────────────
// bg=연한 틴트 배경 / border=테두리 / text=글자 / bar=액센트 바·도트
export const MODULE_C = {
  BF: { bg: "#f3e9e7", border: "#e3d0cc", text: "#8a4d43", bar: "#c09189" },
  DP: { bg: "#e9eefa", border: "#cfdbf3", text: "#365393", bar: "#8ba4d8" },
  IP: { bg: "#f4ede0", border: "#e5d6bd", text: "#83632c", bar: "#c3a771" },
  RP: { bg: "#efeaf6", border: "#ded4ee", text: "#5b4b8f", bar: "#a294c9" },
  MP: { bg: "#e8f0e7", border: "#d2e2d0", text: "#456840", bar: "#8fae89" },
  FP: { bg: "#e7eef0", border: "#cfdfe2", text: "#33646e", bar: "#7fa6ad" },
};

// 모듈 코드 → 색 토큰. 미지의 코드에도 안전하게 중성 폴백을 준다.
export const modC = (code) =>
  MODULE_C[code] ?? { bg: C.bg3, border: C.border, text: C.text2, bar: C.text3 };

// ── 액션바 버튼 색 토큰 ────────────────────────────────────────────────────
// 원칙: 한 화면에 채운(solid) 버튼은 primary 하나(엔진 실행/다음 이동)뿐.
//   나머지 액션은 같은 색을 외곽선으로만 써서 면적을 주지 않는다.
export const BTN = {
  // 중성 외곽선 — 시나리오 관리·이전 등 보조 액션
  neutralBorder: "#C8D1DA", neutralText: "#46525F",
  neutralHoverBg: "#F4F7FA", neutralHoverBorder: "#B4C0CC", neutralActiveBg: "#E9EEF3",
  // 앰버 외곽선 — AI 추천·자동 수행(기존 주황 정체성 유지, 면적 없음)
  aiBorder: "#E0C48F", aiText: "#9A6410",
  aiHoverBg: "#FDF7EC", aiHoverBorder: "#D2B173", aiActiveBg: "#F8EEDA",
  // primary(유일한 solid) — C.acc 계열 그대로
  primaryBg: C.acc, primaryHoverBg: C.accM, primaryText: "#FFFFFF",
};
